import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { OnboardingPageProps } from './components/OnboardingPageContent';

const OnboardingPageContent = lazy(
  () => import('./components/OnboardingPageContent'),
);

export const OnboardingPage = wrapLazyNavigatorScreen(
  (props: OnboardingPageProps) => {
    return <OnboardingPageContent {...props} />;
  },
  ({ route }) => ({
    headerShown: false,
    animationEnabled: route.params?.onDone != null,
    detachPreviousScreen: false,
  }),
);
